import { ChatMessage } from '../../../domain/messages/models/ChatMessage';

export interface ChatMessagesState {
    bySessionId: Record<string, ChatMessage[]>;
}

export const initialChatMessagesState: ChatMessagesState = {
    bySessionId: {},
};
